import { Box, Button, Typography, Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LanguageIcon from '@mui/icons-material/Language';

interface WebsiteRendererProps {
  url: string;
}

const WebsiteRenderer = ({ url }: WebsiteRendererProps) => {
  const [iframeError, setIframeError] = useState(false);

  // Function to handle iframe load error
  const handleIframeError = () => {
    setIframeError(true);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {!iframeError ? (
        <iframe
          src={url}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
          title="Website Preview"
          sandbox="allow-same-origin allow-scripts"
          onError={handleIframeError}
        />
      ) : (
        <Stack
          spacing={3}
          alignItems="center"
          justifyContent="center"
          sx={{ height: '100%', p: 3 }}
        >
          <LanguageIcon sx={{ fontSize: 60, opacity: 0.5 }} />
          <Typography variant="h6" color="text.secondary" align="center">
            This website cannot be displayed in the viewer
          </Typography>
          <Typography color="text.secondary" align="center">
            The website {new URL(url).hostname} has security settings that
            prevent it from being embedded.
          </Typography>
          <Button
            variant="contained"
            startIcon={<OpenInNewIcon />}
            onClick={() => window.open(url, '_blank')}
          >
            Open in New Tab
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default WebsiteRenderer;
